<template>
  <Modal :is-open="mergeWarning" data-test-id="switchBranchWarning">
    <Stack tag="div" direction="col" gap="xl">
      <Stack tag="div" direction="col" gap="none">
        <Heading tag="h3" size="sm" class="text-charcoal-default mb-sm">Are you sure?</Heading>
        <Text tag="p" size="md">
          Changing your branch might affect the availability and price of products in your basket.
        </Text>
      </Stack>
      <Stack tag="div" align="center" justify="end" gap="2xs" class="!w-full">
        <Button variant="neutral" size="md" @click="handleCancelMerge" data-test-id="switchBranchWarningNoBtn">
          No Thanks
        </Button>
        <Button variant="secondary" size="md" @click="handleAcceptMerge" data-test-id="switchBranchWarningYesBtn">
          Yes
        </Button>
      </Stack>
    </Stack>
  </Modal>
</template>

<script setup lang="ts">
const { selectBranch, selectedBranchId } = useBranches();

const { mergeWarning, mergeCancelBranch, setMergeWarning, basketTrayCanOpen } = useUIState();

const handleCancelMerge = async () => {
  await selectBranch(Number(mergeCancelBranch.value));

  setMergeWarning(false, Number(mergeCancelBranch.value));
  basketTrayCanOpen.value = true;

  // remove the branch query parameter from the URL if not accepting merge
  const url = new URL(window.location.href);
  if (url.searchParams.has("branch")) {
    url.searchParams.delete("branch");
    window.history.replaceState({}, "", url.toString());
  }
};

const handleAcceptMerge = async () => {
  setMergeWarning(false, Number(selectedBranchId.value));
  basketTrayCanOpen.value = true;
};
</script>
